<template>
  <div class="container">
    <!-- Header -->
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">{{$t('lbl.customerDataAnalysis.page_header')}}</v-toolbar-title>
      </v-col>
    </v-row>

    <!-- Condition search -->
    <v-row class="custom-form-control custom-figma-1">
      <v-col cols="12" class="search-conditions-display">
        <div class="pl-0 pt-0 pb-0 collapse-search-conditions hide">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('collapse')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-up</v-icon>
            {{$t('btn.common.collapseConditions')}}
          </v-btn>
        </div>
        <div class="pl-0 pt-0 pb-0 expand-search-conditions">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('expand')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-down</v-icon>
            {{$t('btn.common.expandConditions')}}
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <v-col class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-figma-1"
                cols="12" lg="4" md="4">
            <v-row>
              <v-col cols="12" md="4" class="pt-0 pb-0">
                <v-text-field
                  v-model="masterSearchItems.data[0].MSG_SNDR"
                  :label="$t('lbl.common.conditionSearch.findbySender')"
                  @keyup.enter="queryList"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="pt-0 pb-0">
                <v-text-field
                  v-model="masterSearchItems.data[0].MSG_RCVR"
                  :label="$t('lbl.common.conditionSearch.findbyReceiver')"
                  @keyup.enter="queryList"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="pt-0 pb-0 pr-24px">
                <v-text-field
                  v-model="masterSearchItems.data[0].MSG_ID"
                  :label="$t('lbl.common.conditionSearch.findbyMessage')"
                  @keyup.enter="queryList"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col class="comm-header-col date-query-section pb-0 pt-0 mt-0 text-right pr-0 custom-figma-1"
                cols="12" lg="8" md="8">
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-autocomplete
                v-model="masterSearchItems.init.DAT_TYPE"
                :label="$t('lbl.common.conditionSearch.dateType')"
                :items="dateTypes"
                :menu-props="{offsetY: true,}"
                @change="changeDtTp"
                class="custom-selectbox"
                hide-details
                dense
                solo
              ></v-autocomplete>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
              ref="fromdate_menu"
              v-model="fromdate_menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="masterSearchItems.init.FR_DAT"
                  :placeholder="' '"
                  :disabled="masterSearchItems.init.DAT_TYPE == undefined || masterSearchItems.init.DAT_TYPE == null || masterSearchItems.init.DAT_TYPE == ''"
                  :error-messages="masterSearchItems.init.FR_DAT_ERROR"
                  :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                  append-icon="mdi-calendar"
                  dense
                  solo
                  @keypress="formatDate('from', $event)"
                  @change="changeDate('from')"
                  @click:append="on.click"
                ></v-text-field>
              </template>
              <v-date-picker class="date-period-picker" v-model="masterSearchItems.init.FR_DAT" :max="getMaxDate" @input="fromdate_menu = false; changeDate('from')" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="fromdate_menu = false">{{$t('btn.common.cancel')}}</v-btn>
                <v-btn text color="primary" @click="$refs.fromdate_menu.save(masterSearchItems.init.FR_DAT)">{{$t('btn.common.ok')}}</v-btn>
              </v-date-picker>
            </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
              ref="todate_menu"
              v-model="todate_menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="masterSearchItems.init.TO_DAT"
                  :error-messages="masterSearchItems.init.TO_DAT_ERROR"
                  :placeholder="' '"
                  :disabled="masterSearchItems.init.DAT_TYPE == undefined || masterSearchItems.init.DAT_TYPE == null || masterSearchItems.init.DAT_TYPE == ''"
                  :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                  append-icon="mdi-calendar"
                  dense
                  solo
                  @keypress="formatDate('to', $event)"
                  @change="changeDate('to')"
                  @click:append="on.click"
                ></v-text-field>
              </template>
              <v-date-picker class="date-period-picker" :allowed-dates="allowedDates" v-model="masterSearchItems.init.TO_DAT" @input="todate_menu = false; changeDate('to')" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="todate_menu = false">{{$t('btn.common.cancel')}}</v-btn>
                <v-btn text color="primary" @click="$refs.todate_menu.save(masterSearchItems.init.TO_DAT)">{{$t('btn.common.ok')}}</v-btn>
              </v-date-picker>
            </v-menu>
            </div>    
            <!-- Button control-->
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-btn class="btn-width-1 btn btn-top btn-search  mt-0 mb-0" color="primary" @click.native="queryList">
                <v-icon x-small class="mr-2">fa fa-search</v-icon>
                <span class="btn-text">{{$t('btn.common.search')}}</span>
              </v-btn>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-btn class="btn-width-2 btn btn-top  btn-search mt-0 mb-0" color="primary" @click="openDialog()">
                <span class="btn-text">{{$t('lbl.customerDataAnalysis.EDIFileUpload')}}</span>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Grid table page class="page-filter-section" -->
    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg">
        <v-row>
          <v-col lg="6" md="6">
            <v-row>
              <v-col class="page-control-bg" cols="12">
                <div>
                  <v-tooltip top :disabled="isEnableMergeView" :max-width="tooltipWidth" >
                    <template v-slot:activator="{ on}">
                      <div v-on="on" class="btn-tooltip">
                        <v-btn class="btn btn-add" color="#353f61" @click="openMergeView" :disabled="!isEnableMergeView">
                          {{$t('lbl.customerDataAnalysis.mergeView')}}
                        </v-btn>
                      </div>
                    </template>
                    <span>{{$t("msg.customerDataAnalysis.mergerCompareDataTooltipMsg")}}</span>
                  </v-tooltip>
                  <v-tooltip top :disabled="!isEnableDelete" :max-width="tooltipWidth" >
                    <template v-slot:activator="{ on}">
                      <div v-on="on" class="btn-tooltip">
                        <v-btn class="btn btn-delete"  @click="deleteProcessData" :disabled=isEnableDelete>
                          {{$t('btn.common.delete')}}
                        </v-btn>
                      </div>
                    </template>
                    <span>{{$t("msg.customerDataAnalysis.deleteTooltipMsg")}}</span>
                  </v-tooltip>
                  <!-- 203705 08/06/2020 remove the button of "Copy to Matching" -->
                  <!-- <v-btn class="btn-top-table btn-height-custom" color="#353f61" @click="copyToMatching">
                    <v-icon x-small class="mr-2">fas fa-angle-double-right</v-icon>Copy to Matching
                  </v-btn> -->
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="2" md="1"></v-col>
          <v-col lg="4" md="5" class="filter-search">
          <v-row class="justify-end">
            <v-col class="mr-0 pr-0 pl-0" lg="5" md="5">
              <v-select
                v-model="searchBy"
                :items="searchByItems"
                class="search-by data-table-select-box custom-selectbox pla-col mr-0 flat-file-selectbox"
                :placeholder="$t('lbl.common.searchTypePlaceHolder')"
                height="30"
                hide-details
                dense
                solo
                @change="onFilterAnalysis"
              ></v-select>
            </v-col>
            <v-col class="pb-0 pt-0 pl-0 text-search-filter" cols="12" md="6">
              <v-text-field
                v-model="search"
                class="data-table-filter-text-field search-button-data-analysis-table flat-file"
                heigth="30"
                append-icon="fa fa-search"
                :placeholder="$t('lbl.common.searchPlaceHolder')"
                outlined
                hide-details
                dense
                solo
                @input="onFilterAnalysis"
                @click:append="onFilterAnalysis"
                v-on:keyup.enter="onFilterAnalysis"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- First Grid table page -->
    <v-row>
      <!-- // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu -->
      <!-- 2021.12.8 203728 SPKA-305 show bottom border -->
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="pt-0">
        <v-data-table
          v-model="selectMasterRows"
          :headers="SummaryList.headers"
          :items="masterItems"
          :hide-default-footer="true"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :fixed-header="true"
          :height="tableHeight1"
          @page-count="pageCount = $event"
          :class="['list-table data-analysis-table srm-list-table custom-border-table', masterItems.length > 0 ? '' : 'custom-border-table-not-data']"
          item-key="ROWID"
          pb-2
        >
          <template v-slot:header.checkbox="{ header }">
            <v-checkbox
            @change="selectAllChange"
            class="select-checkbox-layout-table align-center justify-center chk-m-auto"
            :color="$vuetify.theme.dark? '#dbd7db' : '#9aaac3'"
            dense
            hide-details
            ></v-checkbox>
          </template>

          <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.ROWID" @click="viewSummDataList($event, item)" v-bind:class="[item.ROWID == selectedMasterItem.ROWID ? 'selected-row' : '']">
                  <!-- 
                    06/01/2021 203737 SPKA-130 issue 82 Add "No." in the first column search result grid
                  -->
                  <td class="index-col">{{ item.ROWID }}</td>
                  <td class="checkbox-col">
                    <v-checkbox
                      id="item.checked"
                      v-model="item.checked"
                      @click.native="selectItemChange($event, item)"
                      @click.native.stop
                      class="select-checkbox-layout-table align-center justify-center chk-m-auto"
                      :color="$vuetify.theme.dark? '#dbd7db' : '#9aaac3'"
                      dense
                      hide-details
                    ></v-checkbox>
                  </td>
                  <td class="sender-col">{{ item.MST_MSG_SNDR }}</td>
                  <td class="receiver-col">{{ item.MST_MSG_RCVR }}</td>
                  <td class="message-col">{{ item.MST_MSG_ID }}</td>
                  <td class="message-format-col">{{ item.MST_MSG_VER }}</td>
                  <td class="message-format-col">{{ messageFormatMap[item.MST_MSG_STD] }}</td>
                  <td class="count-col">{{ formatNumber(item.MSG_CNT) }}</td>
                  <td class="date-col">{{ item.MST_UPD_DT }}</td>
                  <td class="date-col">{{ item.MST_TRAN_DT }}</td>
                  <td class="action-col">
                    <!-- // 2021.12.1 SPKA-297 svg icon -->
                    <v-btn small text icon @click="openLayoutView(item)">
                      <icon-svg iconName="view"/>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!-- 2021.12.8 203728 SPKA-305 show bottom border -->
    <v-row class="custom-form-control custom-figma-1">
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <v-col class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-figma-1"
                cols="12" lg="6" md="6">
          </v-col>
          <v-col class="comm-header-col date-query-section pb-0 pt-0 mt-0 pl-4 text-right pr-0 custom-figma-1 fixed-float"
                cols="12" lg="5" md="4">            
            <v-row>
              <v-col cols="12" lg="" md="4" class="pt-0 pb-0">
                <!-- 203705 fix issues 48 DataAnalysis  -->
                <v-text-field
                  v-model="subGridGrepDataItems.data[0].SEARCH1"
                  label="Search text"
                  @keyup.enter="queryGrepDataList"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="4" md="4" class="pt-0 pb-0">
                <v-text-field
                  v-model="subGridGrepDataItems.data[0].SEARCH2"
                  @keyup.enter="queryGrepDataList"
                  label="Search text"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="4" md="4" class="pt-0 pb-0">
                <v-text-field
                  v-model="subGridGrepDataItems.data[0].SEARCH3"
                  @keyup.enter="queryGrepDataList"
                  label="Search text"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="comm-header-col date-query-section pb-0 pt-0 mt-0 text-right pr-3 custom-figma-1 fixed-float"
                cols="12" lg="1" md="2">
            <div class="pl-0 pt-0 pb-0 btn-control">
              <v-btn block class="btn btn-search btn-width-1" color="primary" @click.native="queryGrepDataList">
                <v-icon x-small class="mr-2">fa fa-search</v-icon>{{$t('btn.common.search')}}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Second Grid table page -->
    <v-row>
      <v-col cols="12" md="12" class="pt-1">
        <v-data-table
          :headers="SummDataList.headers"
          :items="SummDataListItems"
          :hide-default-footer="true"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :fixed-header="true"
          :height="tableHeight2"
          @page-count="pageCount = $event"
          :class="['list-table data-analysis-table srm-list-table custom-border-table', SummDataListItems.length > 0 ? '' : 'custom-border-table-not-data']"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr 
                v-for="item in items" 
                :key="item.ROWID" 
                @click="onClickRow(item)"
                :class="[selectedRow === item.ROWID ? 'selected_row' : '']"
              >
                <!-- 
                    06/01/2021 203737 SPKA-130 issue 82 Add "No." in the first column search result grid
                -->
                <td class="index-col">{{ item.ROWID }}</td>
                <td class="message-format-col">{{ item.MST_PRCS_NO }}</td>
                <td class="sender-col">{{ item.MST_MSG_SNDR }}</td>
                <td class="receiver-col">{{ item.MST_MSG_RCVR }}</td>
                <td class="message-col">{{ item.MST_MSG_ID }}</td>
                <td class="message-format-col">{{ item.MST_MSG_VER }}</td>
                <td class="text-center"><a class="layout-col link-file-text cursor-pointer" @click="viewFile(item)">{{$t('btn.common.view')}}</a></td>
                <td class="date-col">{{ item.MST_UPD_DT }}</td>
                <td class="date-col">{{ item.MST_TRAN_DT }}</td>
                </tr>
            </tbody>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">{{$t('btn.common.reset')}}</v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <!-- Remove unuse code
        <analyzed-layout-dialog v-if="dialog.type == 'layoutView'" class="analyzed-layout-dialog"
        :params="params"
        :id="dialog.id" :ref='"dialog-" + dialog.id'
        :closeDialog="removeDialog" :dragEnd="dialogDragEnd"
        :dragStart="selectDialog" :move="dialogDragEnd"
        :options="dialog.options">
      </analyzed-layout-dialog>

      <upload-fileview-dialog v-if="dialog.type == 'fileUploadView'" class="analyzed-layout-dialog width-1000"
        :edifile="edifile"
        :bizfile="bizfile"
        :id="dialog.id" :ref='"dialog-" + dialog.id'
        :closeDialog="removeDialog" :dragEnd="dialogDragEnd"
        :dragStart="selectDialog" :move="dialogDragEnd"
        :options="dialog.options">
      </upload-fileview-dialog>

       <merge-compare-dialog
        v-if="dialog.type == 'MergeCompare'"
        class="custom-dialog compare-merge-dialog"
        :params="params"
        :id="dialog.id"
        :ref='"dialog-" + dialog.id'
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options">
      </merge-compare-dialog> -->

      <edi-upload-dialog
        v-if="dialog.type == 'ediUploadFile'"
        class="custom-dialog dialog-small"
        :id="dialog.id"
        :callby="'ANALYSIS'"
        :ref='"dialog-" + dialog.id'
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :queryList="queryList"
        :options="dialog.options">
      </edi-upload-dialog>
    </div>

    <!-- Remove unuse code
    <dialogWindow
      ref="mergeCompareInfoDialog"
      size="max"
      title="Merge & Compare"
      detail= 'Please select 2 to 4 items'
      color="validation"
    >
    </dialogWindow>
    <dialogWindow
      ref="warningDialog"
      size="max"
      title="Merge & Compare"
      detail= 'Should be selected rows with the same message type'
      color="validation"
    >
    </dialogWindow>
    <dialogWindow
        ref="deleteWarningDialog"
        size="max"
        title="Delete Data"
        detail= 'There is no selected item'
        color="validation"
      >
    </dialogWindow>
     -->

    <dialogWindow
      ref="warningDialog"
      size="max"
      title="Merge & Compare"
      :detail= "add_valid_str"
      color="validation"
    >
    </dialogWindow>
    <dialogWindow
      ref="deleteConfirmDialog"
      size="max"
      :detail="$t('msg.common.infoConfirm.detail',['delete the selected items'])"
      color="confirmation"
      show-cancel="true"
      @select-ok="onClickDelete"
    >
    </dialogWindow>
    <dialogWindow
      ref="SearchCondition"
      size="max"
      title="Search"
      :detail="$t('msg.common.fromDateValidate')"
      color="validation"
    >
    </dialogWindow>
    <dialogWindow
      ref="validateDate"
      size="max"
      :detail='$t("msg.common.validateDate")'
      color="validation"
    ></dialogWindow>
  </div> <!-- End container -->
</template>

<script>
/* globals Store */
/* Remove unuse code
import ghIcon from '@/vue-dlb/assets/github.svg?raw'
import browserIcon from '@/vue-dlb/assets/browser.svg?raw'
import dialogIcon from '@/vue-dlb/assets/dialog.svg?raw'
import downloadIcon from '@/vue-dlb/assets/download.svg?raw'
import analyzedDialog from '@/vue-dlb/views/analysis/AnalyzedDialog.vue'
import uploadFileviewDialog from '@/vue-dlb/views/commons/UploadFileView.vue'
import mergeCompareDialog from '@/vue-dlb/views/matching/MergeCompareDialog.vue'
import {
  showSuccessMessage,
  showErrorMessage,
  showProgress,
  hideProgress
} from "@/vue-dlb/utils/sys-util.js";
*/

import ediUploadDialog from '@/vue-dlb/views/commons/EdiFileUpload.vue'
import dialogWindow from '@/vue-dlb/components/NewDialog.vue'
import $ from "jquery"
import { resizeTableHeight } from '@/vue-dlb/common/common';

import { debounce } from "lodash"
import { mapState } from "vuex"
import config from '@/vue-caas/config/config.js';
import { deleteDateFormatStr } from '@/vue-dlb/utils/util'
import { beforeOneMonth } from '@/vue-dlb/utils/util'
import { getAppliedTimeZone } from '@/vue-dlb/utils/util';
import { dateValidation } from '@/vue-dlb/utils/util'
import cfg from '@/vue-caas/config/config.js'
import idb from '@/vue-dlb/utils/idb';
// 203737 05/18/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
import SystemProgress from "@/vue-dlb/components/SystemProgress.vue";
// 2021.12.1 SPKA-297 svg icon
import IconSvg from  '@/vue-caas/components/IconBase.vue';

export default {
  components: {
    ediUploadDialog,
    dialogWindow,
    SystemProgress,
    IconSvg,// 2021.12.1 SPKA-297 svg icon
  },

  computed: {
    ...mapState("analysis", {
      masterItems: "masterItems",
      dataItems: "dataItems"
    }),
    // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
    ...mapState("common", {
      sysloadingTitle: "sysloadingTitle"
    }),
    // 203728 SPKA-49 issue 5 apply date conndition
    getMaxDate () {
      if (dateValidation(deleteDateFormatStr(this.masterSearchItems.init.FR_DAT), deleteDateFormatStr(this.masterSearchItems.init.TO_DAT))) {
        return getAppliedTimeZone();
      }
      else {
        this.$refs.SearchCondition.dialog = true;
        return getAppliedTimeZone();
      }
    },
    getMinDate () {
      if (dateValidation(deleteDateFormatStr(this.masterSearchItems.init.FR_DAT), deleteDateFormatStr(this.masterSearchItems.init.TO_DAT))) {
        return this.masterSearchItems.init.FR_DAT;
      }
      else {
        this.$refs.SearchCondition.dialog = true;
        return this.masterSearchItems.init.FR_DAT;
      }
    },
    isEnableMergeView(){
      let mergeItem = this.selectMasterRows[0];
      if(this.selectMasterRows.length >=2 && this.selectMasterRows.length <=4){
        for(let i=0;i < this.selectMasterRows.length ; i++){
          if(mergeItem.MST_MSG_ID != this.selectMasterRows[i].MST_MSG_ID){
            return false
          }
        }
        return true;
      }
      return false;
    },
    isEnableDelete(){
      if(this.selectMasterRows.length > 0){
        return false;
      }
      return true;
    }
  },
  data(){
    return{
    /* Remove unuse code
    dialog2: false,
    icons: {
      gitHub: ghIcon,
      browser: browserIcon,
      download: downloadIcon,
      dialog: dialogIcon
      senders: [],
      styles: [
      { name: 'dialog-1'},
      { name: 'dialog-2'},
      { name: 'dialog-3'}
      ],
      style: null,
      app: process.env.APP,
      quickSearch: {
        get: function () {
          return this.quickSearchFilter;
        },
        set: function ( val ) {
          this.quickSearchFilter = val;
          this.quickSearchFilter && this.quickSearchList();
        }
      },
    },
    */
    tableHeight1:'',
    tableHeight2:'',
    isCreated: false,
    dateTimeFormat: '',
    add_valid_str: '',
    edifile: "",
    bizfile: "",
    parmas: "",
    fromDate: false,
    toDate: false,
    numberFormatter: new Intl.NumberFormat('en-US'),
    fromdate_menu: false,
    fromdate: null,
    maximumItem: 4,
    todate_menu: false,
    todate: null,
    page: 1,
    pageCount: 0,
    itemsPerPage: -1,
    tooltipWidth: 300,
    search: '',
    dialog: false,
    SummaryList: {
      headers: [
        { text: this.$t("tbl.common.columnNo"), value: 'INDEX', width: "30px",},
        { text: '', value: 'checkbox',width: "30px",sortable: false,},
        { text: 'Sender', value: 'MST_MSG_SNDR', width: "150px",  },
        { text: 'Receiver', value: 'MST_MSG_RCVR', width: "150px" },
        { text: 'Message', value: 'MST_MSG_ID', width: "110px" },
        { text: 'Version', value: 'MST_MSG_VER', width: "100px" },
        { text: 'Message Format', value: 'MST_MSG_STD', width: "140px" },
        { text: 'Count', value: 'MSG_CNT', width: "100px"  },
        { text: 'Upload Date', value: 'MST_UPD_DT', width: "250px" },
        { text: 'Document Date', value: 'MST_EDI_CRE_DT', width: "250px"},
        { text: 'Layout View', value: 'LAYOUT_VIEW', width: "100px" },
      ],
      // selected: [],
    },
    /**
     * 06/01/2021 203737 SPKA-130 issue 82 Add "No." in the first column search result grid
     *  */ 
    SummDataList: {
      headers: [
        { text: this.$t("tbl.common.columnNo"), value: 'INDEX', width: "30px",},
        { text: 'File ID', value: 'MST_PRCS_NO', width: "150px",},
        { text: 'Sender', value: 'MST_MSG_SNDR', width: "150px", },
        { text: 'Receiver', value: 'MST_MSG_RCVR', width: "150px", },
        { text: 'Message', value: 'MST_MSG_ID', width: "150px", },
        { text: 'Version', value: 'MST_MSG_VER', width: "100px" },
        { text: 'Upload File', value: 'MST_INPT_FIL_NM', width: "130px" },
        { text: 'Upload Date', value: 'MST_UPD_DT', width: "280px"  },
        { text: 'Transaction Date', value: 'MST_TRAN_DT', width: "280px" }
      ]
    },
    masterSearchItems: {
      header: ['CUST_ID','MSG_SNDR','MSG_RCVR','MSG_ID','DAT_TYPE','FR_DAT','TO_DAT'],
      data: [{
        CUST_ID: '',
        MSG_SNDR: '',
        MSG_RCVR: '',
        MSG_ID: '',
        DAT_TYPE: '',
        FR_DAT: '',
        TO_DAT: ''
      }],
      init: {
        // 203728 SPKA-49 issue 5 apply date conndition
        FR_DAT: beforeOneMonth(),
        TO_DAT: getAppliedTimeZone(),
        FR_DAT_PREV: beforeOneMonth(),
        TO_DAT_PREV: getAppliedTimeZone(),
        FR_DAT_ERROR: [],
        TO_DAT_ERROR: [],
        // DAT_TYPE: ''
        DAT_TYPE: 'UPDT'
      }
    },
    subGridSearchItems: {
      header: ['CUST_ID','MSG_SNDR','MSG_RCVR','MSG_ID','MSG_VER','DAT_TYPE','FR_DAT','TO_DAT'],
      data: [{
        CUST_ID: '',
        MSG_SNDR: '',
        MSG_RCVR: '',
        MSG_ID: '',
        MSG_VER: '',
        DAT_TYPE: '',
        FR_DAT: '',
        TO_DAT: ''
      }]
    },
    subGridGrepDataItems: {
      header: ['CUST_ID','MSG_SNDR','MSG_RCVR','MSG_ID','MSG_VER','DAT_TYPE','FR_DAT','TO_DAT','SEARCH1','SEARCH2','SEARCH3'],
      data: [{
        CUST_ID: '',
        MSG_SNDR: '',
        MSG_RCVR: '',
        MSG_ID: '',
        MSG_VER: '',
        DAT_TYPE: '',
        FR_DAT: '',
        TO_DAT: '',
        SEARCH1: '',
        SEARCH2: '',
        SEARCH3: ''
      }]
    },
    openLayoutViewItems: {
      header: ['CUST_ID','STR_SNDR','STR_RCVR','MSG_STD','MSG_ID','MSG_VER','DAT_TYPE','FR_DAT','TO_DAT','MSG_CNT'],
      data: [{
        CUST_ID: '',
        STR_SNDR: '',
        STR_RCVR: '',
        MSG_STD: '',
        MSG_ID: '',
        MSG_VER: '',
        DAT_TYPE: '',
        FR_DAT: '',
        TO_DAT: '',
        MSG_CNT: ''
      }]
    },
    openMergeViewItems: {
      header: ['CUST_ID','STR_SNDR','STR_RCVR','MSG_STD','MSG_ID','MSG_VER','DAT_TYPE','FR_DAT','TO_DAT','MSG_CNT','PRCS_STS','LAY_PRCS_NO','ALIAS'],
      data: [],
    },
    deletePrcsDataItems: {
      header: ['CUST_ID','MSG_SNDR','MSG_RCVR','MSG_ID','DAT_TYPE','FR_DAT','TO_DAT'],
      data: [],
    },
    searchBy: 'all',
    searchByItems: [
      { text: 'Search by', value: 'all' },
      { text: 'Sender', value: 'MST_MSG_SNDR', },
      { text: 'Receiver', value: 'MST_MSG_RCVR' },
      { text: 'Message', value: 'MST_MSG_ID' },
      { text: 'Version', value: 'MST_MSG_VER' },
      { text: 'Count', value: 'MSG_CNT' },
      { text: 'Upload Date', value: 'MST_UPD_DT' },
      { text: 'Transaction Date', value: 'MST_TRAN_DT' }
    ],
    messageFormatMap : {
      'E' : 'EDIFACT',
      'X' : 'ANSI X12'
    },
    selectedMasterItem : {},
    arrLayoutDialog: [],
    dialogs: [],
    SummDataListItems: [],
    // 203737 SPKA-49 issue 5 apply date conndition
    dateTypes:[
      {value: '', text: 'Search by'},
      {value: 'UPDT', text: 'Upload Date'},
      {value: 'LATR', text: 'Document Date'},
    ],
    dialogId: 1,
    selected: null,
    dialogWidth: 400,
    selectMasterRows: [],
    layoutViewArr: [],
    uploadFileViewArr: [],
    isClick: true,
    isClickLayout: true,
    isLoading: true,
    selectedRow: '',
  }},
  methods: {
    displaySearchConditions(action) {
      if(action === 'expand') {
        $(".date-query-section").css("display", "block");
        $(".data-query-section").css("display", "block");
        $(".expand-search-conditions").css("display", "none");
        $(".collapse-search-conditions").css("display", "block");
      } else {
        $(".date-query-section").css("display", "none");
        $(".data-query-section").css("display", "none");
        $(".expand-search-conditions").css("display", "block");
        $(".collapse-search-conditions").css("display", "none");
      }
    },
    validateDateInput(dateString) {
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      if(!dateString.match(regEx)) return false;  // Invalid format
      var d = new Date(dateString);
      var dNum = d.getTime();
      if(!dNum && dNum !== 0) return false; // NaN value, Invalid date
      return d.toISOString().slice(0,10) === dateString;
    },
    formatDate(side, evt) {
      let dateString = (side === 'from') ? this.masterSearchItems.init.FR_DAT: this.masterSearchItems.init.TO_DAT
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else if ((charCode !== 46 && charCode !== 8 && charCode !== 45 &&  dateString.length === 4 && !dateString.includes("-")) || 
      (charCode !== 46 && charCode !== 8 && charCode !== 45 &&  dateString.length === 7 && dateString[4] === '-' && ((dateString.match(/-/g) || []).length == 1))) {
        dateString += '-';
        (side === 'from') ? (this.masterSearchItems.init.FR_DAT = dateString) : (this.masterSearchItems.init.TO_DAT = dateString)
      } else {
        return true;
      }
    },
    changeDate(side) {
      if (side === 'from') {
        if(!this.validateDateInput(this.masterSearchItems.init.FR_DAT)) {
          this.$refs.validateDate.dialog = true;
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
          return;
        }
        if (this.masterSearchItems.init.FR_DAT > getAppliedTimeZone()) {
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
        }
        if (this.masterSearchItems.init.FR_DAT > this.masterSearchItems.init.TO_DAT) {
          this.masterSearchItems.init.TO_DAT = this.masterSearchItems.init.FR_DAT
        }
      }
      if (side === 'to') {
        if(!this.validateDateInput(this.masterSearchItems.init.TO_DAT)) {
          this.$refs.validateDate.dialog = true;
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
          return;
        }
        if (this.masterSearchItems.init.TO_DAT > getAppliedTimeZone()) {
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
        }
        if (this.masterSearchItems.init.FR_DAT > this.masterSearchItems.init.TO_DAT) {
          this.masterSearchItems.init.FR_DAT = this.masterSearchItems.init.TO_DAT
        }
      }
    },
    onClickRow(item){
      this.selectedRow = item.ROWID;
    },
    // 203728 SPKA-49 issue 5 apply date conndition
    changeDtTp(){
      if(this.masterSearchItems.init.DAT_TYPE == undefined 
        || this.masterSearchItems.init.DAT_TYPE == null
        || this.masterSearchItems.init.DAT_TYPE == ''){

        this.masterSearchItems.init.FR_DAT = ''
        this.masterSearchItems.init.TO_DAT = ''
      }else{
        this.masterSearchItems.init.FR_DAT = this.masterSearchItems.init.FR_DAT||beforeOneMonth()
        this.masterSearchItems.init.TO_DAT = this.masterSearchItems.init.TO_DAT||getAppliedTimeZone()
      }
    },

    /* Remove unuse code
    changeFromDate(str) {
      if (!this.checkPeriod()) {
        this.masterSearchItems.init.FR_DAT = this.masterSearchItems.init.FR_DAT_PREV;
        this.$refs.SearchCondition.dialog = true;
      } else {
        this.masterSearchItems.init.FR_DAT_PREV = str;
      }
    },

    changeToDate(str) {
      if (!this.checkPeriod()) {
        this.masterSearchItems.init.TO_DAT = this.masterSearchItems.init.TO_DAT_PREV;
        this.$refs.SearchCondition.dialog = true;
      } else {
        this.masterSearchItems.init.TO_DAT_PREV = str;
      }
    },

    checkPeriod() {
      let fromDate = new Date(this.masterSearchItems.init.FR_DAT);
      let toDate = new Date(this.masterSearchItems.init.TO_DAT);
      let maxDate = new Date(fromDate);
      maxDate.setMonth(maxDate.getMonth() + 6);
      if (toDate.getTime() < fromDate.getTime() || toDate.getTime() > maxDate.getTime() ) {
        return false;
      }
      return true;
    },
     checkMessageType(item){
      if(this.selectMasterRows[0].MST_MSG_ID != item.MST_MSG_ID){
        this.$refs.warningDialog.dialog = true;
        return false
      }
      this.selectMasterRows.push(item);
      return true
    },
    */
    queryList () {
      // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
      this.isLoading = true;
      // 203728 SPKA-49 issue 5 apply date conndition
      if (dateValidation(deleteDateFormatStr(this.masterSearchItems.init.FR_DAT), deleteDateFormatStr(this.masterSearchItems.init.TO_DAT))) {
        console.log("--------- getSummaryList ----------");
        this.masterSearchItems.data[0].FR_DAT = deleteDateFormatStr(this.masterSearchItems.init.FR_DAT);
        this.masterSearchItems.data[0].TO_DAT = deleteDateFormatStr(this.masterSearchItems.init.TO_DAT);
        this.masterSearchItems.data[0].CUST_ID = $cookies.get('comp-id');
        this.masterSearchItems.data[0].DAT_TYPE = this.masterSearchItems.init.DAT_TYPE;
        Store.dispatch("analysis/getSummaryList", this.masterSearchItems).then(() => {
          this.selectMasterRows = [];
          this.isLoading = false;
        }).catch(() => {
          this.isLoading = false;
        });
      } else {
        this.$refs.SearchCondition.dialog = true;
        this.isLoading = false;
      }
    },

    viewSummDataList (event, selItem) {
      // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
      this.isLoading = true;
      this.selectedMasterItem = selItem;
      console.log("--------- viewSummDataList ----------");
      this.subGridSearchItems.data[0].CUST_ID = $cookies.get('comp-id');
      this.subGridSearchItems.data[0].MSG_SNDR  = selItem.MST_MSG_SNDR;
      this.subGridSearchItems.data[0].MSG_RCVR  = selItem.MST_MSG_RCVR;
      this.subGridSearchItems.data[0].MSG_ID  = selItem.MST_MSG_ID;
      this.subGridSearchItems.data[0].MSG_VER  = selItem.MST_MSG_VER;
      this.subGridSearchItems.data[0].DAT_TYPE  = this.masterSearchItems.data[0].DAT_TYPE;
      this.subGridSearchItems.data[0].FR_DAT = this.masterSearchItems.data[0].FR_DAT;
      this.subGridSearchItems.data[0].TO_DAT = this.masterSearchItems.data[0].TO_DAT;

      Store.dispatch("analysis/getSummaryDataListIndexDb", this.subGridSearchItems).then(() => {
        idb.getDataByTrName('getSummaryDataList').then((value) => {
            this.SummDataListItems = value[0].DataSets[0].DataRows;
            this.isLoading = false;
        }).catch(() => {
          this.isLoading = false;
        });
      }).catch(() => {
        this.isLoading = false;
      });
    },

    queryGrepDataList () {
      this.subGridGrepDataItems.data[0].CUST_ID = this.subGridSearchItems.data[0].CUST_ID;
      this.subGridGrepDataItems.data[0].MSG_SNDR  = this.subGridSearchItems.data[0].MSG_SNDR;
      this.subGridGrepDataItems.data[0].MSG_RCVR  = this.subGridSearchItems.data[0].MSG_RCVR;
      this.subGridGrepDataItems.data[0].MSG_ID  = this.subGridSearchItems.data[0].MSG_ID;
      this.subGridGrepDataItems.data[0].MSG_VER  = this.subGridSearchItems.data[0].MSG_VER;
      this.subGridGrepDataItems.data[0].DAT_TYPE  = this.subGridSearchItems.data[0].DAT_TYPE;
      this.subGridGrepDataItems.data[0].FR_DAT = this.subGridSearchItems.data[0].FR_DAT;
      this.subGridGrepDataItems.data[0].TO_DAT = this.subGridSearchItems.data[0].TO_DAT;
      if (!this.subGridGrepDataItems.data[0].SEARCH1) {
        this.add_valid_str = "First search condition shouldn't be empty";
        this.$refs.warningDialog.dialog = true;
      } else {
        Store.dispatch("analysis/queryGrepDataList", this.subGridGrepDataItems).then(() => {
          this.SummDataListItems = this.dataItems;
        });
      }
    },

    viewFile (item) {
      let index = this.findIndexItem(item, this.uploadFileViewArr, 'ROWID');
      if (index != null) {
        window.layoutFocusView[item.ROWID.toString()]();
        return;
      }
      this.params =  {
        edifile : item.MST_INPT_FIL_NM,
        bizfile : item.MST_BIZ_FIL_NM,
        ROWID : item.ROWID.toString()
      };
      // 203737 05/14/2021 Issue 16 New windown popup doesn't open
      // this.uploadFileViewArr.push(item);
      if (!this.isClick) {
        return;
      }
      this.isClick = false;
      Store.commit('analysis/SET_FILEVIEW_WINDOW_PARAM', Object.assign({}, this.params));
      var w = window.open(`/edimanager/UploadFileView/${item.ROWID}`, '_blank', "width=1028,height=799,left=100,top=30");
      w.params = this.params;
      // 20218.7.13 203728 SPKA-153 close new window expired.
      w.newWindowExpire = true;
      // w.parent = this;// 2021.4.12 203728 SPKA-52 => bug 16
      // w.closePopup = () => {
      //   let index = w.parent.findIndexItem(item, w.parent.uploadFileViewArr, 'ROWID');
      //   w.parent.uploadFileViewArr.splice(index, 1);
      //   Store.commit('analysis/DELETE_FILEVIEW_WINDOW_PARAM', Object.assign({}, w.parent.params));
      //   w.close();
      // }
      w.addEventListener("load", () => {
        this.uploadFileViewArr.push(item);
        this.isClick = true;
        console.log(this.uploadFileViewArr)
      });

      w.addEventListener("message", (data) => {
        let message = data.data.message;
        console.log(message)
        if (message) {
          let index = this.findIndexItem(item, this.uploadFileViewArr, 'ROWID');
          this.uploadFileViewArr.splice(index, 1);
          Store.commit('analysis/DELETE_FILEVIEW_WINDOW_PARAM', Object.assign({}, this.params));
          
          if (message === "btn-close") {
            w.close();
          }
        }
      }, false);
      w.focusPopup = () => {
        w.focus();
      }
      w.theme=false;
      if(this.$vuetify.theme.isDark == true){
            w.theme = this.$vuetify.theme.isDark;
      }
      if (typeof window.fileViewOpenWindow == 'undefined' || typeof window.layoutFocus == 'undefined') {
        window.fileViewOpenWindow = {[item.ROWID.toString()] : w.closePopup};
        window.layoutFocusView = {[item.ROWID.toString()] : w.focusPopup};
      } else {
        window.fileViewOpenWindow[item.ROWID.toString()] = w.closePopup;
        window.layoutFocusView[item.ROWID.toString()] = w.focusPopup;
      }
      // w.onbeforeunload = w.closePopup;
    },

    formatNumber(num) {
      return this.numberFormatter.format(num);
    },

    openLayoutView(item) {
      // let index = this.findIndexItem(item, this.layoutViewArr, 'ROWID');
      // if (index != null) {
      //   window.layoutFocus[item.ROWID.toString()]();
      //   return;
      // }
      let index = this.layoutViewArr.findIndex(e => e.ROWID === item.ROWID);
      if (index > -1) return window.layoutFocus[item.ROWID]();

      this.openLayoutViewItems.data[0].CUST_ID  = $cookies.get('comp-id');
      this.openLayoutViewItems.data[0].STR_SNDR = item.MST_MSG_SNDR;
      this.openLayoutViewItems.data[0].STR_RCVR = item.MST_MSG_RCVR;
      this.openLayoutViewItems.data[0].MSG_STD  = item.MST_MSG_STD;
      this.openLayoutViewItems.data[0].MSG_ID  = item.MST_MSG_ID;
      this.openLayoutViewItems.data[0].MSG_VER  = item.MST_MSG_VER;
      this.openLayoutViewItems.data[0].DAT_TYPE  = this.masterSearchItems.data[0].DAT_TYPE;
      this.openLayoutViewItems.data[0].FR_DAT = this.masterSearchItems.data[0].FR_DAT;
      this.openLayoutViewItems.data[0].TO_DAT = this.masterSearchItems.data[0].TO_DAT;
      this.openLayoutViewItems.data[0].MSG_CNT = item.MSG_CNT;
      this.openLayoutViewItems.data[0].ROWID = item.ROWID;

      this.params = this.openLayoutViewItems.data[0];
      // 203737 05/14/2021 Issue 16 New windown popup doesn't open
      // this.layoutViewArr.push(item);
      if (!this.isClickLayout) {
        return;
      }
      this.isClickLayout = false;
      Store.commit('layout/SET_LAYOUT_WINDOW_PARAM', Object.assign({}, this.params));
      let querystring = 'popup=true&';
      if(this.$vuetify.theme.isDark == true){
        querystring += 'theme=Dark'
      } else {
        querystring += 'theme=Light'
      }
      var w = window.open(`/edimanager/EdiAnalyzedView/${item.ROWID}?${querystring}`, '_blank', "width=1550,height=802,left=100,top=30");
      w.mode = "MergeView";
      w.params = this.params;
      // 20218.7.13 203728 SPKA-153 close new window expired.
      w.newWindowExpire = true;
      if(this.$vuetify.theme.isDark == true){
            w.theme = this.$vuetify.theme.isDark;
      }
      // w.parent = this;// 2021.4.12 203728 SPKA-52 => bug 16
      // w.closePopup = () => {
      //   let index = w.parent.findIndexItem(item, w.parent.layoutViewArr, 'ROWID');
      //   w.parent.layoutViewArr.splice(index, 1);
      //   Store.commit('layout/DELETE_LAYOUT_WINDOW_PARAM', Object.assign({}, w.parent.params));
      //   //closePopup -> clear Data
      //   idb.deleteByKey('getAnalyzedData');
      //   idb.deleteByKey('getLayoutData');
      //   w.close();
      // }
      w.addEventListener("load", () => {
        this.layoutViewArr.push(item);
        this.isClickLayout = true;
        console.log(this.layoutViewArr)
      });

      w.addEventListener("message", (data) => {
        let message = data.data.message;
        console.log(message)
        if (message) {
          let index = this.findIndexItem(item, this.layoutViewArr, 'ROWID');
          this.layoutViewArr.splice(index, 1);
          Store.commit('layout/DELETE_LAYOUT_WINDOW_PARAM', Object.assign({}, this.params));
          //closePopup -> clear Data
          idb.deleteByKey('getAnalyzedData');
          idb.deleteByKey('getLayoutData');
          
          if (message === "btn-close") {
            w.close();
          }
        }
      }, false);
      w.focusPopup = () => {
        w.focus();
      }
      if (typeof window.layoutOpenWindow == 'undefined' || typeof window.layoutFocus == 'undefined') {
        window.layoutOpenWindow = {[item.ROWID.toString()] : w.closePopup};
        window.layoutFocus = {[item.ROWID.toString()] : w.focusPopup};
      } else {
        window.layoutOpenWindow[item.ROWID.toString()] = w.closePopup;
        window.layoutFocus[item.ROWID.toString()] = w.focusPopup;
      }
      // w.onbeforeunload = w.closePopup;
    },

    openMergeView() {
        this.openMergeViewItems.data = [];
        // add by April for test. plz modify according to concept.
        let mergeItem = this.selectMasterRows[0];
        console.log(this.selectMasterRows);
        let total_cnt = 0;
        for(var i = 0; i <this.selectMasterRows.length; i++){
          this.openMergeViewItems.data[i] = {
            CUST_ID: `${this.$cookies.get('comp-id')}`,
            STR_SNDR: `${this.selectMasterRows[i].MST_MSG_SNDR}`,
            STR_RCVR: `${this.selectMasterRows[i].MST_MSG_RCVR}`,
            MSG_STD: `${this.selectMasterRows[i].MST_MSG_STD}`,
            MSG_ID: `${this.selectMasterRows[i].MST_MSG_ID}`,
            MSG_VER: `${this.selectMasterRows[i].MST_MSG_VER}`,
            DAT_TYPE: `${this.masterSearchItems.data[0].DAT_TYPE}`,
            FR_DAT: `${this.masterSearchItems.data[0].FR_DAT}`,
            TO_DAT: `${this.masterSearchItems.data[0].TO_DAT}`,
            MSG_CNT: '',
            PRCS_STS: '',
            LAY_PRCS_NO: '',
            ALIAS: `ALIAS_${this.selectMasterRows[i].ROWID}`
          };
          total_cnt = total_cnt + this.selectMasterRows[i].MSG_CNT;
        }
        this.params = this.openMergeViewItems.data;
        let querystring = 'popup=true&';
        if(this.$vuetify.theme.isDark == true){
          querystring += 'theme=Dark'
        } else {
          querystring += 'theme=Light'
        }
        //[2020-03-26] apply by CLV: Change to open new window
        var w = window.open(`/edimanager/AnalysisCompareMerge?${querystring}`, '_blank', "width=1825,height=800,left=100,top=100");
        w.params = this.params;
        // 20218.7.13 203728 SPKA-153 close new window expired.
        w.newWindowExpire = true;
        w.mode = 'MergeView';
        w.pageTitle = "EDI Analyzed Merge View"
        w.total_cnt = total_cnt;
        if(this.$vuetify.theme.isDark == true){
            w.theme = this.$vuetify.theme.isDark;
        }
        w.closePopup = () => {
          w.close();
        }
        if (typeof window.mergeOpenWindow == 'undefined') {
          window.mergeOpenWindow = {'close' : w.closePopup};
        } else {
          window.mergeOpenWindow['close'] = w.closePopup;
        }
        w.onbeforeunload = w.closePopup;
      // }
    },

    deleteProcessData() {
      //203665 Apply disable/enalble button and tooltip
      this.$refs.deleteConfirmDialog.dialog = true;
    },

    onClickDelete() {
      this.deletePrcsDataItems.data = [];
      for(let i = 0; i < this.selectMasterRows.length; i++) {
        let item = this.selectMasterRows[i];
        if (this.selectedMasterItem.ROWID==item.ROWID) {
          this.selectedMasterItem={};
        }
        this.deletePrcsDataItems.data.push({
          CUST_ID : this.$cookies.get('comp-id'),
          MSG_SNDR : item.MST_MSG_SNDR,
          MSG_RCVR : item.MST_MSG_RCVR,
          MSG_ID : item.MST_MSG_ID,
          MSG_VER : item.MST_MSG_VER,
          DT_TYPE : this.masterSearchItems.data[0].DAT_TYPE,
          FR_DAT : this.masterSearchItems.data[0].FR_DAT,
          TO_DAT : this.masterSearchItems.data[0].TO_DAT
        })
      }
      // 203705 fix issues 51 DataAnalysis
      Store.dispatch("analysis/deleteProcessData", this.deletePrcsDataItems).then(() => {
        this.SummDataListItems=[];
        this.queryList();
      });
    },

    onFilterAnalysis(str) {
      Store.commit('analysis/SET_STORE_ANALYSIS_FILTER', {filter : this.searchBy, str : this.search});
    },

    selectAllChange(value) {
      let maxItem = this.maximumItem;
      let selectAllItems = [];
      if(value){
        for (let i = 0; i < this.masterItems.length; i++) {
          let item = this.masterItems[i];
          item.checked = value;
          selectAllItems.push(item);
        }
        this.selectMasterRows = selectAllItems;
      } else {
        for (let i = 0; i < this.masterItems.length; i++) {
          let item = this.masterItems[i];
          item.checked = false;
        }
        this.selectMasterRows = [];
      }
    },

    /*
    Date: [2020/03/31] Apply by CLV: Open alerts when select items(rows).
    Content: Logic biz: max row selected is up by customer.
    */
    selectItemChange(event, item) {
      let maxItem = this.maximumItem;
      let checked = item.checked;
      if (checked == true) {
        this.selectMasterRows.push(item);
      } else if (checked == false) {
        let index = this.findIndexItem(item, this.selectMasterRows, 'ROWID');
        if (index != null) {
          this.selectMasterRows.splice(index, 1);
        }
      }
    },

    findIndexItem(item, arr, col) {
      let prop = (typeof col == 'undefined') ? 'id' : col;
      let index = arr.findIndex((row) => {
        return row[prop] === item[prop]
      })
      return (index > -1) ? index : null
    },

    openDialog () {
      let type = "ediUploadFile";
      let item = {
        ROWID : 0
      }
      let indexArrDialog = this.findDialog("ediUploadFile_0");
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },

    newDialog (item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },

    removeDialog (dialog) {
      let id = dialog.id
      let index = this.findDialog(id)
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1)
      if (this.selected && this.selected.id === id) this.selected = null
    },

    findDialog (id, dialogs) {
      if (!dialogs) dialogs = this.dialogs
      let index = dialogs.findIndex((val) => {
        return val.id === id
      })
      return (index > -1) ? index : null
    },

    generateDialog (item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({id : id});
      this.dialogId++
      let name = 'Dialog ' + id
      let options = {left : 30 * this.dialogId, top : 30 * this.dialogId};
      return { id, name, type, options }
    },

    dialogDragEnd (obj) {
      let index = this.findDialog(obj.id)
      this.$set(this.dialogs[index].options, 'left', obj.left)
      this.$set(this.dialogs[index].options, 'top', obj.top)
    },

    selectDialog (obj) {
      let index = this.findDialog(obj.id)
      this.selected = this.dialogs[index]
    },

    allowedDates(val){
      let date= getAppliedTimeZone();
      if(val <= date){
        return val;
      }
    }
  },

  created () {
    this.changeDtTp();
    this.dateTimeFormat = config.dateTimeFormat;
    this.SummDataListItems=[];
    this.tooltipWidth = cfg.tooltipWidth;
    this.queryList ();
    this.isCreated = true;
  },

  mounted () {
    /* this.$nextTick(() => {
    }) */
  },

  updated: function() {
    let self = this;
    let arrClassMinus = [".custom-form-control"];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      if(h1 != "200"){
        self.tableHeight1 = h1/2-20-20 + "px";
        self.tableHeight2 = h1/2+20-20 + "px";
      }else{
        self.tableHeight1 = h1-20 + "px";
        self.tableHeight2 = h1-20 + "px";
      }
      this.isCreated = false;
    }

    $(window).resize(function (event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      if(h1 != "200"){
        self.tableHeight1 = h1/2-20-20 + "px";
        self.tableHeight2 = h1/2+20-20 + "px";
      }else{
        self.tableHeight1 = h1-20+ "px";
        self.tableHeight2 = h1-20+ "px";
      }
    })
  },
}
</script>

<style>
  /* .tab-text {
    padding-left: 5px !important;
    justify-content: left !important;
  }
  .v-tabs.theme--dark > .v-item-group {
    background-color: #424242 !important;
  }
  .v-tabs.theme--dark > .v-item-group > .v-window.v-item-group {
    background-color: #424242 !important;
  }
  div.page-info-text {
    padding-top: 20px;
  } */

  /* div.table-pagination ul.v-pagination {
    justify-content: inherit;
  }
  div.table-pagination ul li:not(:first-child):not(:last-child) {
    display : none;
  }
  div.table-pagination ul li button {
    width : 70px;
    height : 40px;
    margin-top : 0px;
    background-color : #3B3E49 !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    color : white !important;
  }
  div.table-pagination ul li:first-child i::before {
    content : "\f0d9";
    font-size : 14px;
  }
  div.table-pagination ul li:first-child i::after {
    content : " Prev";
    font-size : 14px;
    font-family: monospace;
    white-space: pre;
  }
  div.table-pagination ul li:last-child i::before {
    content : "Next ";
    font-size : 14px;
    font-family: monospace;
    white-space: pre;
  }
  div.table-pagination ul li:last-child i::after {
    content : "\f0da";
    font-size : 14px;
  }
  .custom-table-second{
    min-height: 18.5%!important;
    max-height: 18.5%!important;
    height: 18.5%!important;
  }
  .data-analysis-table.custom-table-second .v-data-table__wrapper{
    overflow-y: auto ;
    min-height: 321px  !important;
    max-height: 321px  !important;
  }

  .data-analysis-table.custom-table-first .v-data-table__wrapper{
    overflow-y: auto ;
    min-height: 300px  !important;
    max-height: 301px !important;
  }*/

  .from-date-picker .v-text-field__details {
    display: none;
  }
  .to-date-picker .v-text-field__details {
    display: none;
  }
  .theme--light .data-analysis-table thead {
    /*background: #496D94 !important; */
    border-top: none;
  }
  .theme--dark .data-analysis-table thead {
    background: #191a21 !important;
  }
  .theme--dark.data-analysis-table tbody tr:last-child {
    border-bottom: 1px solid #464952;
  }
  .theme--dark .page-filter-section{
      background-color: #191a21 !important;
      height:35px !important;
      line-height:35px !important;
  }
  .theme--dark.data-analysis-table .checkbox-col {
     width: 76px;
  }
  /* .theme--dark.data-analysis-table .sender-col {
      color: #bbbbbb;
      font-weight: bold;
  }
  .theme--dark.data-analysis-table .receiver-col {
      color: #bbbbbb;
      font-weight: bold;
  }
  .theme--dark.data-analysis-table .message-col {
      color: #bbbbbb;
      font-weight: bold;
  }
  .theme--dark.data-analysis-table .sender-col, .theme--dark.data-analysis-table .receiver-col, .theme--dark.data-analysis-table .message-col{
      color: #C1C7D0;
  }
  .search-child-table{
    padding-left: 10px;
  }*/
  .theme--dark.data-analysis-table .count-col {
      color: #00B8D9;
  }
  .theme--light .data-analysis-table .count-col {
      color: #3db6f3;
  }
  .theme--dark.v-application a {
      color: #2196F3;
  }
  /* 20200911: fix respository */
  /* @media screen and (max-width: 1280px) {
    .file-upload-button{
      width: 132px !important;
    }
    .search-data-analysis-button{
      width:75px !important;
    }
    .date-query-section .d-inline-flex input{
      width: 100px !important;
    }
  } */
  .select-search-filter{
    padding-right:10px !important;
  }
  .data-query-section-items .v-text-field.v-input--dense:not(.v-text-field--outlined) input{
    padding-top: 0px !important;
    width: 200px;
  }
  .theme--light .data-query-section-items .v-text-field.data-table-filter-text-field .v-input__control .v-input__slot{
    background: #F3F5F7 !important;
  }
  /* 203705 update color icon in the Layout View */
  .list-table.data-analysis-table .fa-file-alt:before {
    color: #0082BA
  }
   /* 163189 fix td center */
  .chk-m-auto .v-input--selection-controls__input{
    margin: auto;
  }
  .data-analysis-table .select-checkbox-layout-table.v-input--selection-controls {
    padding-left: 0px !important;
  }
</style>